import { Item, ItemGroup, ItemHeader } from "@/client/components/shad/item";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ItemGroup className="grid grid-cols-3 gap-3">
      <Item variant="outline">
        <ItemHeader>Hira</ItemHeader>
      </Item>
      <Item variant="outline">
        <ItemHeader>Jammer</ItemHeader>
      </Item>
      <Item variant="outline">
        <ItemHeader>PDAR</ItemHeader>
      </Item>
      <Item variant="outline">
        <ItemHeader>Skopa</ItemHeader>
      </Item>
    </ItemGroup>
  );
}
